import * as React from 'react';
import Link from 'next/link';
import styled from 'styled-components';

import { FlyoutTileItem } from '@packages/common';
import { Flex, themeGet } from '@packages/ui';

import { FlyoutTileImage } from './FlyoutTileImage';

const FlexContainer = styled(Flex)`
  padding-left: ${themeGet.space(4)};
  height: 100%;
`;

const TeaserContainer = styled.a`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border: 1px solid ${themeGet.colors('swirl')};
  background-color: ${themeGet.colors('white')};
  margin: ${themeGet.space(1)};
  margin-right: 0;
`;

export const ImageContainer = styled.div`
  position: relative;
`;

export const Text = styled.div`
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  color: ${themeGet.colors('white')};
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  padding: 0 ${themeGet.space(1)};
  font-size: ${themeGet.fontSize(1)};
  background-color: ${themeGet.colors('sandDune')};
`;

export const SubText = styled.div`
  bottom: 0;
  overflow: hidden;
  text-align: center;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: ${themeGet.colors('kilamanjaro')};
  padding: ${themeGet.space(1)} ${themeGet.space(2)};
`;

export interface FlyoutTilesProps {
  items?: FlyoutTileItem[];
  count?: number;
}

export const FlyoutTiles: React.FC<FlyoutTilesProps> = ({ items = [], count = 2 }) => {
  const splittedItems = items.slice(0, count);
  return (
    <FlexContainer flexWrap="wrap" flexDirection="column">
      {splittedItems &&
        splittedItems.map((flyoutTile: FlyoutTileItem, idx) => {
          const anchorTargetProps =
            flyoutTile.target && flyoutTile.target === '_blank'
              ? {
                  target: '_blank',
                  rel: 'nofollow noopener',
                }
              : {};

          return (
            <Link prefetch={false} key={flyoutTile.href} href={flyoutTile.href}>
              <TeaserContainer
                href={flyoutTile.href}
                {...anchorTargetProps}
                key={`flyout-tile-item-${idx}-${flyoutTile.uuid}`}
              >
                <ImageContainer>
                  <FlyoutTileImage flyoutTile={flyoutTile} />
                  <Text>{flyoutTile.text}</Text>
                </ImageContainer>
                <SubText>{flyoutTile.subtext}</SubText>
              </TeaserContainer>
            </Link>
          );
        })}
    </FlexContainer>
  );
};
